export default "__VITE_ASSET__xdLnwrw0__"